import PISet from "@/assets/js/pi-set";

export default class Role {
  constructor(dutyData) {
    this.shortDisplayName = `${dutyData.shortName} - ${dutyData.duty.substring(0, 2).toLowerCase()}`;
    this.longDisplayName = `${dutyData.prettyName} (${dutyData.duty})`;
    this.displayName = this.shortDisplayName;
    this.positionGroup = dutyData.positionGroup;
    this.stratum = dutyData.stratum;
    this.identifier = dutyData.identifier;
    this.prettyName = dutyData.prettyName;
    this.shortName = dutyData.shortName;
    this.duty = dutyData.duty;

    this.instructions = new PISet(dutyData);
  }
}
